import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { StripePaymentCardService } from '../../../providers/stripe-payment-card.service';
import { Stripe_customer } from '../../../models/accounting/banking/stripe_customer';
import { Stripe_credit_card } from '../../../models/accounting/banking/stripe_credit_card';
import { StripeModalAddCreditCardComponent } from '../stripe-modal-add-credit-card/stripe-modal-add-credit-card.component';
import { faCreditCard, faPlus,  faDotCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCcVisa, faCcAmex, faCcDiscover, faCcMastercard } from '@fortawesome/free-brands-svg-icons';


@Component({
  standalone: false,
  selector: 'app-stripe-choose-payment-method',
  templateUrl: './stripe-choose-payment-method.component.html',
styleUrls:  ['./stripe-choose-payment-method.component.css']
})
export class StripeChoosePaymentMethodComponent implements OnInit {

  faCreditCard = faCreditCard;
  faPlus = faPlus;
  faDotCircle = faDotCircle;
  faCcVisa = faCcVisa;
  faCcAmex = faCcAmex;
  faCcDiscover = faCcDiscover;
  faCcMastercard = faCcMastercard;

  customers: Stripe_customer[] = [];

  @Output() payment_method_selected$: EventEmitter<Stripe_credit_card> =  new EventEmitter<Stripe_credit_card>();
  @Output() error$: EventEmitter<string> = new EventEmitter<string>();
  @Input() competition_organizer_id: string;

  constructor(private modal: NgbModal, private paymentCardService: StripePaymentCardService) { }

  ngOnInit(): void {
    this.paymentCardService.get_list(this.competition_organizer_id).then(customers => {
    this.customers = customers;
  }).catch(error => {
    this.error$.emit(error);
  });
  }

 onSelectCard(card: Stripe_credit_card){
    this.payment_method_selected$.emit(card);
  }

    addPaymentMethod(){
      let modal_ref_payment = this.modal.open(StripeModalAddCreditCardComponent, { size: 'lg' });
      modal_ref_payment.componentInstance.competitionOrganizerId = this.competition_organizer_id;
      modal_ref_payment.componentInstance.card_added$.subscribe((card: Stripe_credit_card) => {

        //Does customer exist?
        let selected_customer: Stripe_customer = null;
        this.customers.forEach((customer, i) => {
          if(card.system_customer_id == customer.system_customer_id){
            selected_customer = customer;
          }
        });

        if(selected_customer == null) {
          selected_customer = modal_ref_payment.componentInstance.selected_customer;
          this.customers.push(selected_customer);

          this.customers.sort( function(a_customer, b_customer) {
              if((a_customer.last_name + a_customer.first_name) < (b_customer.last_name + b_customer.first_name)){
                  return -1;
              } else if((a_customer.last_name + a_customer.first_name) > (b_customer.last_name + b_customer.first_name)){
                  return 1;
              } else {
                  return 0;
              }
          });

        }


        selected_customer.credit_card_list.push(card);

        selected_customer.credit_card_list.sort( function(credit_card_a, credit_card_b) {
          if(credit_card_a.last_4 < credit_card_b.last_4){
            return -1;
          } else if(credit_card_a.last_4 > credit_card_b.last_4){
            return 1;
          } else {
            return 0;
          }
        });

        //Indicate selected in view too
        card.selected = true;

        this.payment_method_selected$.emit(card);

        modal_ref_payment.close();

      }, error =>{
        this.error$.emit(error);
      });

    }


}
